import { SxProps } from '@mui/system';

export const checkIconStyle: SxProps = {
	mr: 1,
	'> span': {
		fontSize: 12,
	},
};
